import TransferTrackingDetails from '@components/transferTracking/TransferTrackingDetails';
import TransferTrackingStatus from '@components/transferTracking/TransferTrackingStatus';
import { STEPS } from '@constant/steps';
import { useCurrentStep } from '@context/MainContext';
import { isEmpty } from '@helpers/String';
import { withContentLayout } from '../hoc/withContentLayout';

const FormSection = (props) => {
	const currentStep = useCurrentStep();

	// TO-DO: this is the current solution, this might change in the future
	if (isEmpty(currentStep)) {
		return null;
	}

	const showStatusComponent = [STEPS.START_TRACKING, STEPS.NO_DATA, STEPS.LINK_EXPIRED, STEPS.NOT_READY, STEPS.ORDER_EXPIRED].includes(currentStep);

	return showStatusComponent ? <TransferTrackingStatus /> : <TransferTrackingDetails />;
};

export const ContentMain = withContentLayout(FormSection);
